<template>
<div class="chapter">
<div class="inner_page">
<p class="cont">Contents</p>
<p class="toc"><a href="#/07a_Introduction">Introduction by Hugh McIlvanney</a></p>
<p class="toc"><a href="#/08_Prologue">PROLOGUE: 1903</a></p>
<p class="toc"><a href="#/09_Part1">BOOK I</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-1">Chapter 1</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-2">Chapter 2</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-3">Chapter 3</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-4">Chapter 4</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-5">Chapter 5</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-6">Chapter 6</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-7">Chapter 7</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-8">Chapter 8</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-9">Chapter 9</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-10">Chapter 10</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-11">Chapter 11</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-12">Chapter 12</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-13">Chapter 13</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-14">Chapter 14</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-15">Chapter 15</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-16">Chapter 16</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-17">Chapter 17</a></p>
<p class="toc1"><a href="#/10_Book1#ch1-18">Chapter 18</a></p>
<p class="toc"><span href="#/11_Part2" title="Link target outside of Sample">BOOK II</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-1" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-2" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-17" title="Link target outside of Sample">Chapter 17</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-18" title="Link target outside of Sample">Chapter 18</span></p>
<p class="toc1"><span href="#/12_Book2#ch2-19" title="Link target outside of Sample">Chapter 19</span></p>
<p class="toc"><span href="#/13_Part3" title="Link target outside of Sample">BOOK III</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-1" title="Link target outside of Sample">Chapter 1</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-2" title="Link target outside of Sample">Chapter 2</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-3" title="Link target outside of Sample">Chapter 3</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-4" title="Link target outside of Sample">Chapter 4</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-5" title="Link target outside of Sample">Chapter 5</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-6" title="Link target outside of Sample">Chapter 6</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-7" title="Link target outside of Sample">Chapter 7</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-8" title="Link target outside of Sample">Chapter 8</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-9" title="Link target outside of Sample">Chapter 9</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-10" title="Link target outside of Sample">Chapter 10</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-11" title="Link target outside of Sample">Chapter 11</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-12" title="Link target outside of Sample">Chapter 12</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-13" title="Link target outside of Sample">Chapter 13</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-14" title="Link target outside of Sample">Chapter 14</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-15" title="Link target outside of Sample">Chapter 15</span></p>
<p class="toc1"><span href="#/14_Book3#ch3-16" title="Link target outside of Sample">Chapter 16</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Contents.vue?1857fee3